/* pdp-lightbox.js — click a product gallery image to open it enlarged. Vanilla, no libraries.
   Works for the formula PDPs (.pdp-gal) and the bundle PDP (.bnd-gal). Full-screen overlay, full-resolution image (1800 px wide),
   arrows + swipe between the gallery images, Esc / close button / backdrop click, focus trap, body scroll lock.
   Pinch-zoom is left to the browser (touch-action: pinch-zoom on the stage; swipes are only read from single-finger gestures). */
(function () {
  'use strict';
  if (window.__pdpLb) return;
  window.__pdpLb = true;
  var d = document, SEL = '.pdp-gal__slide, .bnd-gal__slide', W = 1800;
  var css = '.pdp-gal__slide[data-lb],.bnd-gal__slide[data-lb]{cursor:zoom-in}' +
    '.pdp-gal__slide[data-lb]:focus-visible,.bnd-gal__slide[data-lb]:focus-visible{outline:3px solid #171735;outline-offset:-3px}' +
    '.pdp-lb{position:fixed;inset:0;z-index:2147483000;display:none;background:rgba(23,23,53,.94);color:#fff;font-family:inherit}' +
    '.pdp-lb.is-open{display:block;animation:pdplb .18s ease-out}' +
    '@keyframes pdplb{from{opacity:0}to{opacity:1}}' +
    '@media (prefers-reduced-motion:reduce){.pdp-lb.is-open{animation:none}}' +
    '.pdp-lb__stage{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding:56px 16px;touch-action:pinch-zoom}' +
    '.pdp-lb__img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;border-radius:8px;background:#fff;user-select:none;-webkit-user-drag:none}' +
    '.pdp-lb__b{position:absolute;display:flex;align-items:center;justify-content:center;width:48px;height:48px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.16);color:#fff;font-size:26px;line-height:1;cursor:pointer}' +
    '.pdp-lb__b:hover{background:rgba(255,255,255,.3)}.pdp-lb__b:focus-visible{outline:3px solid #C2ED97;outline-offset:2px}' +
    '.pdp-lb__x{top:8px;right:8px}.pdp-lb__p{left:8px;top:50%;margin-top:-24px}.pdp-lb__n{right:8px;top:50%;margin-top:-24px}' +
    '.pdp-lb__ct{position:absolute;left:0;right:0;top:20px;text-align:center;font-size:13px;font-weight:600;letter-spacing:.04em;pointer-events:none}' +
    '.pdp-lb[data-one] .pdp-lb__p,.pdp-lb[data-one] .pdp-lb__n,.pdp-lb[data-one] .pdp-lb__ct{display:none}' +
    'html.pdp-lb-lock,html.pdp-lb-lock body{overflow:hidden}' +
    '@media (max-width:600px){.pdp-lb__p,.pdp-lb__n{top:auto;bottom:12px;margin-top:0}.pdp-lb__stage{padding:64px 8px 72px}}';
  var st = d.createElement('style'); st.textContent = css; d.head.appendChild(st);

  var lb, img, ct, bx, bp, bn, items = [], idx = 0, opener = null, sx = 0, sy = 0, multi = false;

  function big(u) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + W) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + W; }
  function build() {
    if (lb) return;
    lb = d.createElement('div'); lb.className = 'pdp-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product image viewer');
    lb.innerHTML = '<div class="pdp-lb__stage"><img class="pdp-lb__img" alt="" decoding="async"></div><div class="pdp-lb__ct" aria-live="polite"></div>' +
      '<button type="button" class="pdp-lb__b pdp-lb__x" aria-label="Close image viewer">&times;</button>' +
      '<button type="button" class="pdp-lb__b pdp-lb__p" aria-label="Previous image">&#8249;</button>' +
      '<button type="button" class="pdp-lb__b pdp-lb__n" aria-label="Next image">&#8250;</button>';
    d.body.appendChild(lb);
    img = lb.querySelector('.pdp-lb__img'); ct = lb.querySelector('.pdp-lb__ct');
    bx = lb.querySelector('.pdp-lb__x'); bp = lb.querySelector('.pdp-lb__p'); bn = lb.querySelector('.pdp-lb__n');
    bx.addEventListener('click', close); bp.addEventListener('click', function () { go(-1); }); bn.addEventListener('click', function () { go(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('pdp-lb__stage')) close(); });
    lb.addEventListener('touchstart', function (e) { multi = e.touches.length > 1; if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive: true });
    lb.addEventListener('touchmove', function (e) { if (e.touches.length > 1) multi = true; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (multi || e.touches.length || !e.changedTouches.length) { if (!e.touches.length) multi = false; return; }
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  function show() {
    var it = items[idx]; img.src = big(it.src); img.alt = it.alt; ct.textContent = (idx + 1) + ' / ' + items.length;
    lb.toggleAttribute('data-one', items.length < 2);
    [1, -1].forEach(function (k) { var n = items[(idx + k + items.length) % items.length]; if (n && items.length > 1) { var im = new Image(); im.src = big(n.src); } });
  }
  function go(k) { if (items.length < 2) return; idx = (idx + k + items.length) % items.length; show(); }
  function open(slide) {
    var wrap = slide.parentNode, list = [].slice.call(wrap.querySelectorAll(SEL));
    items = list.map(function (s) { var im = s.querySelector('img'); return im ? { src: im.currentSrc || im.src, alt: im.alt || '' } : null; });
    var keep = []; list.forEach(function (s, i) { if (items[i]) keep.push(i); });
    idx = keep.indexOf(list.indexOf(slide)); items = items.filter(Boolean); if (idx < 0) idx = 0;
    // the visible src can be a small srcset candidate: prefer the plain src attribute (800 wide) and upscale by URL
    items = list.map(function (s) { var im = s.querySelector('img'); return im ? { src: im.getAttribute('data-pdp-src') || im.getAttribute('src') || im.src, alt: im.alt || '' } : null; }).filter(Boolean);
    build(); opener = slide;
    var sbw = innerWidth - d.documentElement.clientWidth;
    d.documentElement.classList.add('pdp-lb-lock'); if (sbw > 0) d.body.style.paddingRight = sbw + 'px';
    lb.classList.add('is-open'); show(); bx.focus();
  }
  function close() {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open'); img.removeAttribute('src');
    d.documentElement.classList.remove('pdp-lb-lock'); d.body.style.paddingRight = '';
    if (opener && opener.focus) try { opener.focus({ preventScroll: true }); } catch (e) {}
    opener = null;
  }
  d.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest(SEL); if (!s || !s.querySelector('img') || (lb && lb.contains(s))) return;
    e.preventDefault(); open(s);
  });
  d.addEventListener('keydown', function (e) {
    if (lb && lb.classList.contains('is-open')) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'Tab') {
        var f = [bx, bp, bn].filter(function (b) { return b.offsetParent !== null; }), i = f.indexOf(d.activeElement);
        e.preventDefault(); f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches(SEL + '[data-lb]')) { e.preventDefault(); open(e.target); }
  });
  function arm() {
    [].forEach.call(d.querySelectorAll(SEL), function (s) {
      if (s.hasAttribute('data-lb') || !s.querySelector('img')) return;
      var im = s.querySelector('img'); s.setAttribute('data-lb', ''); s.tabIndex = 0; s.setAttribute('role', 'button');
      s.setAttribute('aria-label', 'Enlarge image' + (im.alt ? ': ' + im.alt : ''));
    });
  }
  arm(); d.addEventListener('DOMContentLoaded', arm); addEventListener('load', arm);
})();
